import React, { useState } from "react";
import { Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";

const DeleteTaskModal = ({ preview, previewHandler, data, successHandler }) => {
  const [deleteLoader, setdeleteLoader] = useState(false);
  const { http } = global.services;

  const deleteFileHandler = () => {
    setdeleteLoader(true);
    http
      .delete(`company-task/${data.id}`)
      .finally(() => setdeleteLoader(false))
      .then(() => {
        toast.success("Task deleted successfully");
        successHandler(data);
      })
      .catch(({ data }) => toast.error(data?.error ?? "Something went wrong"));
  };

  return (
    <Modal
      visible={preview}
      centered
      className="delete-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Delete Task</h2>
      <p>Are you sure you want to delete {data?.title}?</p>
      <div className="action-box">
        <button onClick={previewHandler}>Cancel</button>
        <button className="delete" onClick={deleteFileHandler}>
          {deleteLoader ? <BeatLoader size={8} color="#fff" /> : "Delete"}
        </button>
      </div>
    </Modal>
  );
};

export default DeleteTaskModal;
